<template>
    <div class="nodeobserber">
        <slot />
        <div v-if="loading" v-scroll='{handler}' class="sentinels isLoadMore">{{ loading }}</div>
    </div>
</template>
<script>
export default {
    name: 'intersectionobser',
    props:{
        loading: String,
    },
    data(){
        return {

        }
    },
    methods:{
        handler(){
            this.$emit('handler')
        }
    }
}
</script>